import {ApiClient as Api} from '@hconnect/apiclient'
import {useQuery} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {JobsToBeDone} from '../types'

export const JobsToBeDoneQueryKey = 'get-jobs-to-be-done-items'

type GetJobsToBeDoneQueryParams = {
  fromDate?: string
  toDate?: string
}

export const useJobsToBeDone = (
  plantUpmId: string,
  associatedRole: string,
  queryParams: GetJobsToBeDoneQueryParams
) => {
  const path = `/jobs-to-be-done/api/${plantUpmId}/jobs-to-be-done?associatedRole=${associatedRole}`

  return useQuery<JobsToBeDone[], AxiosError>({
    queryKey: [JobsToBeDoneQueryKey, queryParams, plantUpmId, associatedRole],
    queryFn: async () => {
      const response = await Api.axiosInstance.get<JobsToBeDone[]>(path, {params: queryParams})
      return response.data
    }
  })
}
